import { Navigate, useLocation, useRoutes } from "react-router-dom";
import Login from "../pages/authentication/Login";
import ResetPassword from "../pages/authentication/ResetPassword";
import AuthLayout from "../layout/auth";
import Signup from "../pages/authentication/SignUp";
import Verification from "../pages/authentication/Verification";
import PageTransition from "../components/UIElements/pageTransition";

import { AnimatePresence } from "framer-motion";
import React from "react";
import DashboardLayout from "../layout/dashboard";
import Dashboard from "../pages/dashboard";
import Employments from "../pages/employments";
import EmploymentDetails from "../pages/employments/details";

import TimeSheet from "../pages/timesheet";
import TimesheetDetails from "../pages/timesheet/details";
import JobBoard from "../pages/job-board";
import JobBoardDetails from "../pages/job-board/details";
import PostJob from "../pages/job-board/post-job";
import Profile from "../pages/profile";
import Schedule from "../pages/schedule";
import AuthGuard from "../hooks/useAuthGuard";
import Candidate from "../pages/job-board/candidate";
import ScheduleDetails from "../pages/schedule/details";
import RoleManagement from "../pages/profile/role";
import Requests from "../pages/requests";
import EditProfile from "../pages/profile/edit";

export default function Router() {
  const routes = useRoutes([
    {
      path: "auth",
      element: <AuthLayout />,
      children: [
        {
          path: "sign-in",
          element: (
            <PageTransition>
              <Login />
            </PageTransition>
          ),
        },
        {
          path: "reset-password",
          element: (
            <PageTransition>
              {" "}
              <ResetPassword />
            </PageTransition>
          ),
        },
        {
          path: "sign-up",
          element: (
            <PageTransition>
              {" "}
              <Signup />{" "}
            </PageTransition>
          ),
        },
        {
          path: "verification",
          element: (
            <PageTransition>
              {" "}
              <Verification />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "dashboard",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Dashboard />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "employment",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <Employments />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: "request",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <EmploymentDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <EmploymentDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "requests",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <Requests />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },

    {
      path: "timesheet",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <TimeSheet />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <TimesheetDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "job-board",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <JobBoard />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: "post",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <PostJob />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: "candidate/:id",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <Candidate />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <PageTransition>
              <JobBoardDetails />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "schedule",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <Schedule />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              <PageTransition>
                {" "}
                <ScheduleDetails />{" "}
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "profile",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Profile />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: ":id",
          element: (
            <AuthGuard>
              <PageTransition>
                <RoleManagement />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: "edit",
          element: (
            <AuthGuard>
              <PageTransition>
                <EditProfile />
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/auth/sign-in" />,
    },
  ]);

  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      {routes && React.cloneElement(routes, { key: location.pathname })}
    </AnimatePresence>
  );
}
